import JSONModel from "sap/ui/model/json/JSONModel";
import { RoleEnum, UserToken } from "@ang/shared-types";

export type AuthState = {
	isAuthenticated: boolean;
	token: string | null;
	user?: { userId: string; username: string; card_code?: string | null };
	role: RoleEnum | null;
	roles: RoleEnum[];
};

const model = new JSONModel({
	isAuthenticated: false,
	token: null,
	user: undefined,
	role: null,
	roles: [],
} as AuthState);

export function getAuthModel() {
	return model;
}

export function setAuthFromToken(token: string) {
	// trust server; decode only to prefill UI state
	const payload = JSON.parse(atob(token.split(".")[1])) as UserToken & {
		role?: RoleEnum;
	};
	console.log("Token:");
	console.log(token);
	console.log("Payload:");
	console.log(payload);
	model.setData({
		isAuthenticated: true,
		token,
		user: {
			userId: payload.userId,
			username: payload.username,
			card_code: payload.card_code ?? null,
			profit_code: payload.profit_code ?? null,
		},
		role: (payload.role as RoleEnum) ?? null,
		roles: payload.role ? [payload.role as RoleEnum] : [],
	});
	sessionStorage.setItem("jwt", token);
}

export function clearAuth() {
	model.setData({
		isAuthenticated: false,
		token: null,
		user: undefined,
		role: null,
		roles: [],
	});
	sessionStorage.removeItem("jwt");
}
